<template>
  <v-container fluid>
    <v-row >
      <v-col
        v-for="card in formatedElevators"
        :key="card.id"
        :md="card.flex"
        cols="12"
      >
        <v-card>
          <v-img
            :src="card.src != '' ? card.src : require('@/assets/view_media_default.png')"
            class="white--text align-end"
            gradient="to top right, rgba(0,0,0,0), rgba(0,0,0,.33)"
            height="200px"
          />

          <v-card-title>

            <v-badge
              :content="card.isNew ? $t('display/offer:create.table.new') : false"
              :value="card.isNew"
              color="secondary"
            >
              {{card.title}}
            </v-badge>



          </v-card-title>
          <v-card-subtitle>
            <div>{{$t('common:type')}}: {{card.type}}</div>
            <div>{{$t('display/offer:create.table.total-playouts')}}: {{card.playouts > 0 ? card.playouts : $t('display/offer:create.table.not-enough-data')}}</div>
          </v-card-subtitle>

          <v-card-actions>
            <v-spacer></v-spacer>

            <v-btn
              @click="hideElevator(card.id)"
              icon>
              <v-icon>visibility_off</v-icon>
            </v-btn>

            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  v-bind="attrs"
                  v-on="on"
                  icon>
                  <v-icon>info</v-icon>
                </v-btn>
              </template>
              <span>{{$t('common:tags')}}: {{ card.tags }}</span>
            </v-tooltip>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>

export default {
  name: "GridElevators",
  props: {
    elevators: Array
  },
  data() {
    return {
      formatedElevators: []
    }
  },
  created() {
    this.formatElevator(this.elevators);
  },
  methods: {
    formatElevator(items) {
      let elevators = items;
      if (items === null) elevators = [];

      this.formatedElevators = [];
      elevators.forEach(
        (elevator) => {
          let item = {
            title: elevator.name,
            src: '',
            flex: 3,
            isNew: elevator.isNew,
            playouts: elevator.playouts !== null ? elevator.playouts : 0,
            type: elevator.buildingType === null ? '~' : this.getTagText(elevator.buildingType),
            tags: this.getTagText(elevator.tags),
            id: elevator.elevatorId
          };

          if (elevator.imageData !== null) {
            item.src = "/static/elevator/" + elevator.imageData;
          }
          this.formatedElevators.push(item)
        }
      );
    },
    hideElevator(elevatorId) {
      this.$emit('hideElevator', elevatorId);
    },
    getTagText(tags) {
      let isTagsEmpty = !tags;
      let tagsLabel = '~';
      if (!isTagsEmpty) {
        tagsLabel = '';
        for(let i = 0; i < tags.length; i++) {
          tagsLabel += tags[i].name + ', ';
        }

        tagsLabel = tagsLabel.slice(0, -2);
      }

      return tagsLabel;
    }
  }
}
</script>
